import * as TYPES from './actions/types';

export const initialState = {
  treatmentSummaryItems: null,
};

const treatmentSummaryReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.TREATMENT_SUMMARY_LOADED_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.TREATMENT_SUMMARY_LOADED_FAILED:
      newState = { ...state, ...action.state };
      break;
    case TYPES.UNSEEN_TREATMENT_SUMMARY_COUNT_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.UNSEEN_TREATMENT_SUMMARY_COUNT_FAILED:
      newState = { ...state, ...action.state };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default treatmentSummaryReducer;
